<template>
    <div class="report-grade">
        <div class="top clearfix">
            <div class="title">
                <slot name="title">{{ $root.t('forms-report_component-general_assessment') }}</slot>
                <span class="total-answers">{{ grades.length }} {{ $root.t('forms-report_component-answers') }}</span>
            </div>
            <div
                :class="'grade-holder ' + gradeClass(average)"
                v-if="hasAnswers"
            >
                <span class="grade">{{ average }}</span>
                <div class="icons">
                    <span class="icon" v-for="(width, i) in icons" :key="i">
                        <span
                            class="icon-fill"
                            v-bind:style="{ width: width + '%' }"
                        ></span>
                    </span>
                </div>
            </div>
        </div>
        <div class="distribuition" v-if="hasAnswers">
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-grade_very_good') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[4]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[4])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-grade_good') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[3]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[3])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-grade_neutral') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[2]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[2])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-grade_bad') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[1]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[1])) }}%
                </div>
            </div>
            <div class="distribuition-row">
                <span class="label" for="">{{ $root.t('forms-report_component-grade_very_bad') }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[0]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[0])) }}%
                </div>
            </div>
        </div>
        <div class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}
        </div>
    </div>
</template>
<script>
import MathHelper from "./../../helpers/Math";
export default {
    props: {
        useGrade: {
            type: Boolean,
            default: false,
        },
        answers: Array,
        gradeClassMethod: Function,
    },
    computed: {
        grades() {
            let grades = [];
            for (let a in this.answers) {
                let answer = this.answers[a];
                if (this.useGrade) {
                    grades.push(answer.grade);
                } else {
                    grades.push(answer.valueNumber);
                }
            }
            return grades;
        },
        hasAnswers: function () {
            return this.grades.length > 0 ? true : false;
        },
        gradeClass: function () {
            return this.gradeClassMethod;
        },
        distributedGrades: function () {
            let distributedGrades = [0, 0, 0, 0, 0];
            for (var i = 0; i < this.grades.length; i++) {
                let grade = this.round(this.grades[i]);
                distributedGrades[grade - 1]++;
            }
            return distributedGrades;
        },
        average: function () {
            var sum = 0;
            for (var i = 0; i < this.grades.length; i++) {
                sum += this.round(this.grades[i]);
            }
            var avg = sum / this.grades.length;
            return this.round(avg, 1);
        },
        icons: function () {
            let icons = [];
            let average = this.average;
            for (var i = 0; i < 5; i++) {
                let width = average - i;
                if (width >= 1) {
                    width = 100;
                } else if (width > 0) {
                    width = this.round(width * 100);
                } else {
                    width = 0;
                }
                icons.push(width);
            }
            return icons;
        },
    },
    methods: {
        gradesNumberToPercent: function (number) {
            return (number / this.grades.length) * 100;
        },
        round: MathHelper.round,
    },
};
</script>
